import { Modal } from 'antd';

/**
 * BE'nin grup kardeş kontrolü için döndüğü durum kodu: grup maddesi Telif Sonrası'na geçirilirken ya da
 * TS - Madde Atama'dan ilerletilirken gruptaki diğer maddeler henüz Telif Sonrası'na geçmemişse karar
 * reddedilir, onay metni gövdede hazır gelir.
 */
export const GROUP_SIBLINGS_CONFLICT_STATUS = 409;

/**
 * Karar isteği grup kardeş uyarısıyla reddedildiyse onay modalını açar. Kullanıcı onaylarsa `onConfirm`
 * çağrılır; çağıran taraf aynı gövdeyi `force: true` ile yeniden gönderir.
 *
 * @param error RTK Query `error` objesi.
 * @param onConfirm "Yine de devam et" seçilince çalışır; dönen promise modalın yüklenme durumunu sürer.
 * @returns Uyarı açıldıysa `true`, çağıran taraf akışı burada keser.
 */
export const confirmGroupSiblingsConflict = (error, onConfirm) => {
  if (error?.status !== GROUP_SIBLINGS_CONFLICT_STATUS) return false;

  Modal.confirm({
    title: 'Grup maddesi uyarısı',
    // İstekte `Accept` gönderilmediği için BE ld+json döner (metin `hydra:description`'da);
    // problem+json şeklinde aynı metin `detail`'dadır. Metin React text'i olarak basılır, kaçırılmaz.
    content: <div style={{ whiteSpace: 'pre-line' }}>{error.data?.['hydra:description'] ?? error.data?.detail}</div>,
    okText: 'Yine de devam et',
    cancelText: 'Vazgeç',
    onOk: onConfirm,
  });

  return true;
};
